module.exports = __webpack_public_path__ + "img/guide_pic.8a0cdef3.png";